import { render } from "./ClientDocuments.vue?vue&type=template&id=1679eef1&scoped=true&ts=true"
import script from "./ClientDocuments.vue?vue&type=script&lang=ts"
export * from "./ClientDocuments.vue?vue&type=script&lang=ts"

import "./ClientDocuments.vue?vue&type=style&index=0&id=1679eef1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1679eef1"]])

export default __exports__